module.exports = __webpack_public_path__ + "img/ruanjian.fe1717f9.png";